import React, { PropsWithChildren } from 'react';
import { useDispatch } from 'react-redux';
import Box, { BoxProps } from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { OpenAPIV3_1 } from "openapi-types";
import _, { Dictionary } from 'lodash';
import RequestIcon from '@mui/icons-material/Upload';
import ResponseIcon from '@mui/icons-material/FileDownload';


const Pane: React.FC<PropsWithChildren<BoxProps>> = (props) => {
    return (
        <Box
            {...props}
            sx={{
                flexGrow: 1,
                m: 0,
                ...props.sx
            }} >
            {props.children}
        </Box>
    );
};

export interface SplitPaneProps {
    req: React.ReactElement;
    res: React.ReactElement;
}

const SplitPane: React.FC<SplitPaneProps> = ({ req, res }) => {
    const dispatch = useDispatch();

    return (
        <Box sx={{
            display: 'flex',
            flex: '1 1'
        }}>
            <Pane sx={{
                flex: 1,
                mr: 0.5,
            }}>
                <Box sx={{ display: 'flex', mb: 0.5 }}><RequestIcon /><Typography>{'Request'}</Typography></Box>
                {req}
            </Pane>
            <Pane sx={{
                flex: 1,
                ml: 0.5,
            }}>
                <Box sx={{ display: 'flex', mb: 0.5 }}><ResponseIcon /><Typography>{'Response'}</Typography></Box>
                {res}
            </Pane>
        </Box>
    );
};

export default SplitPane;
